import { Box, Card as MUICard, CardProps as MUICardProps, Skeleton } from "@mui/material";

interface CardProps extends MUICardProps {
  loading?: boolean;
  skeletonHeight?: number;
}

const Card = ({
  loading = false,
  skeletonHeight = 100,

  // MUI Props
  children,
  ...props
}: CardProps) => {
  return (
    <MUICard {...props}>
      {loading ? (
        <Box
          sx={{
            height: 0,
            overflow: "hidden",
            paddingTop: `${skeletonHeight}%`,
            position: "relative",
          }}
        >
          <Skeleton
            variant="rounded"
            animation="wave"
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          />
        </Box>
      ) : (
        children
      )}
    </MUICard>
  );
};

export default Card;
